// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 991 ? "resolve" : chunkId) + "." + {"98":"110bf118","357":"9442b9ab","532":"2ad24b49","991":"758a4683"}[chunkId] + ".css";
};